angular.module("ainapp")
    .controller("OpeningStockController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Opening Stocks";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.init = function () {
                $scope.filter = {
                    Keyword: "",
                };
            }
            $scope.init();


            $scope.SalesSource = new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                        MainService.OpeningStockInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success(false);
                            toastr.error($scope.NetworkErrorLan);
                        })
                    }
                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                            },
                            VoucherNo: {
                                type: "string",
                            },

                            TotalQuantity: {
                                type: "float",
                            },

                            CreatedDate: {
                                type: "date",
                            },
                            "CreatedBy.UserName":{
                                type: "string",
                            }

                        }
                    }
                },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
            });

            $scope.SalesFactory = {
                toolbar: ["excel"],
                stretch: true,
                selectable: true,
                groupable: false,
                height: 550,
                sortable: true,
                resizable: true,
                dataSource: $scope.SalesSource,
                pageable: true,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                filterable: true,

                columns: [



                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                        headerTemplate: "{{LanguageData.date}}",
                                            },
                    {
                        field: "VoucherNo",
                        title: "Voucher Number",
                        headerTemplate: "{{LanguageData.vouchernumber}}",
                        //                        template: "<div style='text-align: right'>#=kendo.toString(VocherNumber, 'n')#</div>",

                                            },
                    {
                        field: "TotalQuantity",
                        title: "Total Quantity",
                        //                        headerTemplate: "{{LanguageData.totaldebit}}",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalQuantity, 'n')#</div>",

                                            },
//                    {
//                        field: "Product.Name",
//                        title: "Product",
//
//                                            },

{
                        field: "CreatedDate",
                        template: "#= kendo.toString(kendo.parseDate(CreatedDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Created Date"
                    },

                    {
                        field: "CreatedBy.UserName",
                        title: "Created By"
                    },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='Delete(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click=\"PrintInvoice(dataItem.Id, 'Opening Stock', dataItem.VoucherNo)\"></button><button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button>  ",
                        width: '140px'
                        },


                                        ],
            };


            $scope.Edit = function (data) {
                $state.go("editOpeningStock", {
                    VoucherId: data.Id
                })
            };

            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: "",
                    Type: "",
                };
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            };

            $scope.SearchKendo = function () {
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            }


            $scope.SelectedDataForDelete = {};
            $scope.Delete = function (data) {

                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $('#deleteModal').modal('show');
                }
            }

            $scope.deleteWithConfirm = function () {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteOpeningStock($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data.Message == "Success") {
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    } else {
                        toastr.warning(response.data.Message);
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.View = function (data) {
                if (!$scope.PageAccessInfo.IsView) {
                    toastr.info("You Dont Have Access To View Data, Please Contact Admin");
                } else {
                    // $state.go("viewOpeningStock", {
                    //     VoucherId: data.Id
                    // })

                    var url = $state.href('viewOpeningStock', {
                        VoucherId: data.Id
                    });
                    window.open(url, '_blank');
                }
            }


                }])
